import { render, staticRenderFns } from "./PopupUser.vue?vue&type=template&id=5e4c4171&"
import script from "./PopupUser.vue?vue&type=script&lang=js&"
export * from "./PopupUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports